@if (_active) {
  <kendo-window
    title="{{ _isNew ? 'Add new record' : 'Edit record' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm">
    <form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">
      <div class="row">
        <div class="col-12">
          <div class="Transfer-section-header">
            <div class="Transfer-section-header-title">Transfer Request</div>
            <div class="header-actions">
              @if (!_isProcessed) {
                <button class="asap-btn" kendoButton (click)="_onSave($event)">
                  <span>
                    <img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" />
                  </span>Save & Close
                </button>
              }
              <button class="asap-btn" kendoButton (click)="_onCancel()">
                <span>
                  <img [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" />
                </span>Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-row-margin">
        <div class="col-12 col-xl-7 small-pad-right">
          <div class="TransferWidget">
            <div class="row">
              <div class="col-12 col-xl-6">
                <div class="row">
                  <div class="col-12">
                    <p class="titleStandardStyle">Transfer from</p>
                  </div>
                  <div class="col-12 margin-top-10">
                    <div class="row">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-2">
                            <label class="control-label">From Account</label>
                          </div>
                          <div class="col-10 combobox_contaainer">
                            <kendo-combobox #kendo_combo_fromaccounts
                              [data]="_fromAccounts"
                              [disabled]="_model != null && _model.id != null"
                              [suggest]="true"
                              formControlName="fromAccount"
                              [formControl]="_fromAccountsDD"
                              class="bordered whiteselect"
                              [textField]="'name'"
                              [valueField]="'id'"
                              placeholder="Select From Account"
                              (valueChange)="_fromAccountsSelectionChanged($event)"
                              [(ngModel)]="_selectedFromAccounts"
                              required>
                            </kendo-combobox>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-2">
                            <label class="control-label">From Site</label>
                          </div>
                          <div class="col-10 combobox_contaainer">
                            <kendo-combobox #kendo_combo_fromsites
                              [data]="_fromSites"
                              [disabled]="_form.get('fromAccount').value == null || (_model != null && _model.id != null)"
                              [suggest]="true"
                              class="bordered whiteselect"
                              [textField]="'name'"
                              [valueField]="'id'"
                              placeholder="Select From Site"
                              (valueChange)="_fromSitesSelectionChanged($event)"
                              formControlName="fromSite"
                              [(ngModel)]="_selectedFromSites"
                              required>
                            </kendo-combobox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl-6">
                <div class="row">
                  <div class="col-12">
                    <p class="titleStandardStyle">Transfer to</p>
                  </div>
                  <div class="col-12 margin-top-10">
                    <div class="row">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-2">
                            <label class="control-label">To Account</label>
                          </div>
                          <div class="col-10 combobox_contaainer">
                            <kendo-combobox #kendo_combo_toaccounts
                              [data]="_toAccounts"
                              [disabled]="_form.get('fromAccount').value == null || _form.get('fromSite').value == null || (_model != null && _model.id != null)"
                              [suggest]="true"
                              [formControl]="_toAccountsDD"
                              formControlName="toAccount"
                              class="bordered whiteselect"
                              [textField]="'name'"
                              [valueField]="'id'"
                              placeholder="Select To Account"
                              (valueChange)="_toAccountsSelectionChanged($event)"
                              [(ngModel)]="_selectedToAccounts"
                              required>
                            </kendo-combobox>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-2">
                            <label class="control-label">To Site</label>
                          </div>
                          <div class="col-10 combobox_contaainer">
                            <kendo-combobox #kendo_combo_tosites
                              [data]="_toSites"
                              [disabled]="_form.get('fromAccount').value == null || _form.get('fromSite').value == null || _form.get('toAccount').value == null || (_model != null && _model.id != null)"
                              [suggest]="true"
                              class="bordered whiteselect"
                              [textField]="'name'"
                              [valueField]="'id'"
                              placeholder="Select To Site"
                              (valueChange)="_toSitesSelectionChanged($event)"
                              formControlName="toSite"
                              [(ngModel)]="_selectedToSites"
                              required>
                            </kendo-combobox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="section-separator"></div>
              </div>
              <div class="col-12 col-xl-6">
                <div class="row">
                  <div class="col-2">
                    <label class="control-label">Notes</label>
                  </div>
                  <div class="col-10 combobox_contaainer">
                    <textarea id=""
                      name=""
                      class="Transfer_notes_textarea"
                    formControlName="notes"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl-6">
                <div class="row">
                  <div class="col-2">
                    <label class="control-label">Schedule Date</label>
                  </div>
                  <div class="col-10 combobox_contaainer">
                    <kendo-datepicker [format]="'yyyy/MM/dd'"
                      (valueChange)="_onScheduleDateChange($event)"
                      formControlName="scheduleDate"
                      class="smalldatePicker">
                    </kendo-datepicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        @if (!_assettransfergMode) {
          <div class="col-12 col-xl-5 small-pad-left">
            <div class="TransferWidget">
              <div class="row">
                <div class="col-12">
                  <p class="titleStandardStyle">Select or Scan Model #</p>
                </div>
                <div class="col-12 display-flex margin-top-10">
                  <div class="row flex-1">
                    <div class="col-2">
                      <label class="control-label">Model #</label>
                    </div>
                    <div class="col-8 combobox_contaainer">
                      <kendo-combobox appDebounceFilter #Kendo_Combobox_Assets
                        class="bordered newFormControlWidth"
                        [data]="modelsDataFiltered"
                        [suggest]="true"
                        [filterable]="true"
                        [placeholder]="'Select an Model'"
                        id="modelNumber"
                        name="modelNumber"
                        formControlName="modelNumber"
                        [textField]="'number'"
                        [valueField]="'id'"
                        (keyup.enter)="_handleModelKeyEnter()"
                        (filterChange)="_handleModelsFilter($event)"
                        (opened)="scrollModelCombobox($event)"
                        (valueChange)="_modelSelectionChanged($event)"
                        [attr.disabled]="_form.get('toAccount').value == null || _form.get('toSite').value == null? 'disabled' : null"
                        [attr.required]="true"
                        [disabled]="_form.get('toAccount').value == null || _form.get('toSite').value == null"
                        class="bordered">
                        <!-- Not Existing Template -->
                        <ng-template kendoDropDownListNoDataTemplate>
                          <div class="stocksettEnabledContainer">
                            @if (!_assetsAuth?.canAdd) {
                              <span
                                class="missing-item-txt">No data found.<br/>
                              </span>
                            }
                          </div>
                        </ng-template>
                        <!-- Item Template -->
                        <ng-template kendoComboBoxItemTemplate let-dataItem>
                          <div class="transactions-receive-stock-dropdown-item">
                            <div class="truncate">{{ dataItem.number }}@if (dataItem.name) {
                              <span> | {{ dataItem.name }}</span>
                            }</div>
                          </div>
                        </ng-template>
                      </kendo-combobox>
                      <!-- <span class="asap-input-icon">
                      <img class="addIcon"
                        (click)="_openAssetsList()"
                        [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                      </span> -->
                    </div>
                  </div>
                </div>
                <!-- <div class="col-12 margin-top-2">
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <div class="col-2">
                      <label class="control-label">
                        Attach Document
                      </label>
                    </div>
                    <div #kendo_uploader_wrapper class="col-10 transaction-move-input-fields" style="display:flex;">
                      <kendo-upload
                        #kendo_uploader
                        [class.active]="true"
                        [class.disabled]="_pageState == 4"
                        [batch]="false"
                        [autoUpload]="false"
                        [multiple]="true"
                        class="NextToLabelUpload requiredDropZone"
                        (select)="_fileSelectedChanges($event)"
                        (remove)="_fileRemoveEventHandler($event)"
                        formControlName="stream">
                        <kendo-upload-messages
                          [select]="_uploaderSelectMessage"
                          [dropFilesHere]="''">
                        </kendo-upload-messages>
                      </kendo-upload>
                      <a  class="cursor-pointer" (click)="_onUploadClick()"
                        [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4">
                        <img  class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                      </a>
                      <a  (click)="_showDocumentsGrid=true" class="asap-input-icon"
                        [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4">
                        <img _ngcontent-sqy-c791="" class="addIcon" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'">
                      </a>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      }
      @if (_assettransfergMode) {
        <div class="col-12 col-xl-5 small-pad-left">
          <div class="TransferWidget">
            <div class="row">
              <div class="col-12">
                <p class="titleStandardStyle">Select or Scan Asset #</p>
              </div>
              <div class="col-12 display-flex margin-top-10">
                <div class="row flex-1">
                  <div class="col-2">
                    <label class="control-label">Asset #</label>
                  </div>
                  <div class="col-8 combobox_contaainer">
                    <kendo-combobox appDebounceFilter #Kendo_Combobox_Assets
                      class="bordered newFormControlWidth"
                      [data]="assetsDataFiltered"
                      [suggest]="true"
                      [filterable]="true"
                      [placeholder]="'Select an Asset'"
                      id="assetNumber"
                      name="assetNumber"
                      formControlName="assetNumber"
                      [textField]="'assetNumber'"
                      [valueField]="'id'"
                      (keyup.enter)="_handleAssetKeyEnter()"
                      (filterChange)="_handleAssetsFilter($event)"
                      (opened)="scrollCombobox($event)"
                      [attr.disabled]="_form.get('toAccount').value == null || _form.get('toSite').value == null? 'disabled' : null"
                      [attr.required]="true"
                      [disabled]="_form.get('toAccount').value == null || _form.get('toSite').value == null">
                      <!-- Not Existing Template -->
                      <ng-template kendoDropDownListNoDataTemplate>
                        <div class="stocksettEnabledContainer">
                          @if (!_assetsAuth?.canAdd) {
                            <span
                              class="missing-item-txt">
                              No data found.<br />
                            </span>
                          }
                        </div>
                      </ng-template>
                      <!-- Item Template -->
                      <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <div class="transactions-receive-stock-dropdown-item">
                          <div class="truncate">{{ dataItem.assetNumber }}@if (dataItem.assetName) {
                            <span> | {{ dataItem.assetName }}</span>
                          }</div>
                        </div>
                      </ng-template>
                    </kendo-combobox>
                    <!-- <span class="asap-input-icon">
                    <img class="addIcon"
                      (click)="_openAssetsList()"
                      [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                    </span> -->
                  </div>
                </div>
              </div>
              <!-- <div class="col-12 margin-top-2">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2">
                    <label class="control-label">
                      Attach Document
                    </label>
                  </div>
                  <div #kendo_uploader_wrapper class="col-10 transaction-move-input-fields" style="display:flex;">
                    <kendo-upload
                      #kendo_uploader
                      [class.active]="true"
                      [class.disabled]="_pageState == 4"
                      [batch]="false"
                      [autoUpload]="false"
                      [multiple]="true"
                      class="NextToLabelUpload requiredDropZone"
                      (select)="_fileSelectedChanges($event)"
                      (remove)="_fileRemoveEventHandler($event)"
                      formControlName="stream">
                      <kendo-upload-messages
                        [select]="_uploaderSelectMessage"
                        [dropFilesHere]="''">
                      </kendo-upload-messages>
                    </kendo-upload>
                    <a  class="cursor-pointer" (click)="_onUploadClick()"
                      [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4">
                      <img  class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                    </a>
                    <a  (click)="_showDocumentsGrid=true" class="asap-input-icon"
                      [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4">
                      <img _ngcontent-sqy-c791="" class="addIcon" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'">
                    </a>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    }
    <!-- Details -->
    <div class="col-12">
      <div class="transactionWidget with-grid">
        <div class="flex-space-between transaction-move-grid-header-wrapper">
          <div class="titleStandardStyle d-flex">
            <div class="asap-grid-remove_new">
              Selected Items&nbsp; &nbsp;
            </div>
            @if (_gridSelectedAssets.length > 0) {
              <div>
                <button class="asap-grid-remove" (click)="_onRemoveDetailsBatch()">
                  <div class="asap-grid-remove-icon">
                    <img src="/assets/menu/enterprise/remove-icon.svg" />
                  </div>
                  <div class="asap-grid-remove-text">Delete Selected Items</div>
                </button>
              </div>
            }
          </div>
          <div class="transaction-move-grid-top-actions">
            <div class="transaction-move-grid-top-actions-radio">
              <input type="radio" #NewToOldSort
                id="new-to-old-items"
                name="transaction-move-duration"
                value="new"
                [formControl]="_sortingSelected"
                kendoRadioButton />
                <label class="k-radio-label" [for]="'new-to-old-items'">
                  Newest To Oldest
                </label>
              </div>
              <div class="transaction-move-grid-top-actions-radio">
                <input type="radio"
                  id="old-to-new-items"
                  name="transaction-move-duration"
                  value="old"
                  [formControl]="_sortingSelected"
                  kendoRadioButton />
                  <label class="k-radio-label" [for]="'old-to-new-items'">
                    Oldest To Newest
                  </label>
                </div>
              </div>
            </div>
            <asap-grid-layout #SelectedItemsGrid
              [singleSelect]="false"
              [selectable]="true"
              [groupingEnabled]="false"
              [pagingEnabled]="true"
              [headerEnable]="false"
              [searchEnabled]="false"
              [editColumnsEnabled]="false"
              [reloadDataEnabled]="false"
              [refreshInitData]="true"
              [isData]="true"
              [entityName]="_entity"
              [addNewFormEnabled]="false"
              [enableSiteSelection]="false"
              [orderEnable]="false"
              [page]="_assetsPageName"
              [deletedEnabled]="false"
              [filteringEnable]="false"
              [data]="_assetDataArray"
              [clientSidePaging]="true"
              [selectByField]="'id'"
              (onRowSelectionChanges)="_onDetailsRowSelectionChanges($event)"
              class="transaction-move-grid ReceiveTransactionDetails">
              @for (column of _assetsTransactionGridFields; track column; let i = $index) {
                @if (column.selected) {
                  @if (!column.isTemplate) {
                    <ng-template pageListColumn
                      kendoGridCellTemplate
                      [width]="100"
                      [field]="column.field"
                      [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                      [type]="column.type"
                      let-item>
                      @if (column.type == 'date' && column.isCustomField == false && column.field != 'assetStatus.statusId' && column.field != 'condition.conditionId') {
                        {{ item[column.field] | dateFormat }}
                      }
                      @if (column.type != 'date' && column.isCustomField == false && column.field != 'assetStatus.statusId' && column.field != 'condition.conditionId' ) {
                        {{column.field | complexFieldValue: item}}
                      }
                      @if (column.isCustomField == true) {
                        {{item[column.field]}}
                      }
                    </ng-template>
                  }
                  @if (column.isTemplate) {
                    <ng-template pageListColumn
                      kendoGridCellTemplate
                      [width]="100"
                      [field]="column.field"
                      [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                      [type]="column.type"
                      let-item>
                      @if (column.type == 'date' && column.isCustomField == false && column.field != 'assetFiles.file.thumbnail') {
                        {{ item[column.field] | dateFormat }}
                      }
                      @if (column.type != 'date' && column.isCustomField == false && column.field != 'assetFiles.file.thumbnail') {
                        {{column.field | complexFieldValue: item}}
                      }
                      @if (column.formatType == costPriceFormatType) {
                        {{column.field | complexFieldValue: item | costFormat}}
                      }
                      @if (column.isCustomField == true) {
                        {{item[column.field]}}
                      }
                    </ng-template>
                  }
                }
              }
              <ng-template pageListColumn
                [name]="'Action'"
                let-item>
                <ng-container>
                  <div class="asap-grid-remove" (click)="_handleRemoveSelectedItem(item)">
                    <div class="asap-grid-remove-icon">
                      <img src="/assets/menu/enterprise/remove-icon.svg" />
                    </div>
                    <div class="asap-grid-remove-text">Delete</div>
                  </div>
                </ng-container>
              </ng-template>
            </asap-grid-layout>
          </div>
        </div>
      </div>
    </form>
  </kendo-window>
}
